module.exports = __webpack_public_path__ + "assets/images/coin-misc.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-misc.png
// module id = 1510
// module chunks = 1